module.exports = __webpack_public_path__ + "static/WEDDING E&M-471-b03ef6ed9d9fa759ffd1fdcf812fe80a.jpg";